export default __webpack_public_path__ + "static/media/24popup.e458b5e9.jpg";